import React from "react";
import { MarketingLayout } from "../../components/marketing/MarketingLayout";
import { SEO } from "../../components/seo/SEO";
import { breadcrumbSchema } from "../../components/seo/schema";

/** Shared "coming soon" index for /resources/guides and /resources/tools —
 * the architecture (Article model + category field) already supports these;
 * content is added deliberately rather than auto-generated. */
export function ResourcesComingSoon({ label, description }) {
  const breadcrumb = [{ name: "Home", path: "/" }, { name: "Resources", path: "/resources" }, { name: label, path: `/resources/${label.toLowerCase()}` }];
  return (
    <MarketingLayout breadcrumb={breadcrumb}>
      <SEO title={`${label} | ServiceGuru Pro`} description={description} path={`/resources/${label.toLowerCase()}`} jsonLd={[breadcrumbSchema(breadcrumb)]} />
      <section className="max-w-2xl mx-auto px-5 lg:px-8 py-24 text-center">
        <h1 className="text-4xl font-black tracking-tight mb-4" data-testid={`resources-${label.toLowerCase()}-h1`}>
          {label}
        </h1>
        <p className="text-slate-400 text-[15px]">
          We're building out {label.toLowerCase()} content — check back soon, or explore the <a href="/resources/blog" className="text-blue-400 hover:text-blue-300 underline">blog</a> in the meantime.
        </p>
      </section>
    </MarketingLayout>
  );
}

export function GuidesIndex() {
  return <ResourcesComingSoon label="Guides" description="In-depth guides for evaluating and adopting home service management software." />;
}

export function ToolsIndex() {
  return <ResourcesComingSoon label="Tools" description="Free tools and calculators for home service businesses." />;
}
